import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Subject, takeUntil } from 'rxjs';
import { DynamicsFieldsService } from 'src/app/shared/services';
import { InformationCollectorByPaymentComponent } from '../../modules/information-collector-by-payment/collector/information-collector-by-payment.component';
import { InformationCollectorByPaymentService } from '../../modules/information-collector-by-payment/collector/services/information-collector-by-payment.service';

@Component({
    selector: 'app-customer-reference-form',
    standalone: true,
    imports: [
        MatButtonModule,
        MatDialogModule,
        MatIconModule,
        FormsModule,
        MatTooltipModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatOptionModule,
        InformationCollectorByPaymentComponent,
    ],
    templateUrl: './customer-reference-form.component.html',
    styleUrls: ['./customer-reference-form.component.scss'],
})
export class CustomerReferenceFormComponent implements OnInit, OnDestroy {
    private unsubscribe$: Subject<void>;
    constructor(
        private dynamicsFieldsService: DynamicsFieldsService,
        private informationCollectorByPaymentService: InformationCollectorByPaymentService
    ) {
        this.unsubscribe$ = new Subject<void>();
    }

    ngOnInit(): void {
        this.getCollectorForms();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    getCollectorForms(): void {
        this.informationCollectorByPaymentService
            .getCollectorForms$()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: (form: (FormGroup | null)[]) => {
                    this.dynamicsFieldsService.setCollectorForms(form);
                },
            });
    }
}
